import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from '~/src/layout/_layout';
import { initialProps } from '~/src/helpers/basePageFunc';
import OnlineServices from '~/src/components/Intercom/services/onlineServices';

class IntercomServicesPage extends Component {

  static async getInitialProps(options) {
    const { hostname } = await initialProps(options);
    const path = options.pathname;
    return ({
      hostname,
      path
    });
  }

  render() {
    const { hostname, path } = this.props;
    const cityText = this.props.city.cityIn;
    const title = `Дополнительные услуги домофонии от Дом.ру ${cityText}`;
    const description = `Провайдер Дом.ру предлагает воспользоваться дополнительными услугами домофонии в ${this.props.city.cityIn}. Вы можете приобрести дополнительный домофонный ключ или установить аудиотрубку. Остались вопросы? Позвоните ☎ ${this.props.city.phone}`;
    return (
      <Layout
        title={title}
        description={description}
        hostname={hostname}
        withMenu={true}
        withFooter={true}
        withChat={true}
        noindex={true}
      >
        <OnlineServices path={path}/>
      </Layout>
    );
  }
}

IntercomServicesPage.propTypes = {
  city: PropTypes.object,
  path: PropTypes.string,
  hostname: PropTypes.string,
};

IntercomServicesPage.defaultProps = {
  city: {},
  path: '',
  hostname: '',
};

const mapStateToProps = state => ({
  city: state.city.currentCity,
});


export default connect(mapStateToProps)(IntercomServicesPage);
